<template>
  <a-popover title="Kadaster huisnummer formattering" placement="topLeft">
    <template slot="content">
      <div style="max-width: 500px;">
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th></th>
            <th>Nummer</th>
            <th>Letter</th>
            <th>Toevoeging</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Hoofdstraat 80</td>
            <td>80</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Hoofdstraat 80A</td>
            <td>80</td>
            <td>A</td>
            <td></td>
          </tr>
          <tr>
            <td>Hoofdstraat 80-4</td>
            <td>80</td>
            <td></td>
            <td>4</td>
          </tr>
          <tr>
            <td>Hoofdstraat 80-4B</td>
            <td>80</td>
            <td></td>
            <td>4B</td>
          </tr>
          <tr>
            <td>Hoofdstraat 80A-4B</td>
            <td>80</td>
            <td>A</td>
            <td>4B</td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
    <information-outline-icon></information-outline-icon>
  </a-popover>
</template>

<script>
export default {
  name: "NumberFormatInformationComponent",
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
}
</script>
<style scoped>
</style>
